"use client";

import { IntlMessagesUpdater } from "@/components/IntlMessagesUpdater/IntlMessagesUpdater";
import { RoutersProvider as SharedRoutersProvider } from "@cloudspire/shared/hooks/useRouters";

/**
 * @typedef {object} Props
 * @prop {string} accountHostname
 * @prop {string} frontHostname
 * @prop {React.ReactNode} children
 */
/**
 * @param {Props} props
 */
export function RoutersProvider({ children, ...otherProps }) {
  return (
    <SharedRoutersProvider {...otherProps}>
      <IntlMessagesUpdater />

      {children}
    </SharedRoutersProvider>
  );
}
